import React from 'react'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { useTabQuery } from 'hooks/useQueryState'
import SearchHotWords from './HotWordsTab'
import SavedListTab from './SavedListTab'

export default function Search() {
  const [tab, setTab] = useTabQuery('searchTab', 'hot-words')

  return (
    <div className="flex h-[calc(100vh-98px)] min-h-0 flex-col">
      <Tabs
        value={tab}
        onValueChange={setTab}
        className="flex min-h-0 flex-1 flex-col space-y-4"
      >
        <div className="flex items-center gap-8">
          <h2 className="text-3xl font-bold tracking-tight">Search</h2>
          <TabsList>
            <TabsTrigger value="hot-words">热词列表和配置</TabsTrigger>
            <TabsTrigger value="positive">正向词</TabsTrigger>
            <TabsTrigger value="blacklist">黑名单词</TabsTrigger>
          </TabsList>
        </div>
        <TabsContent
          value="hot-words"
          className="mt-0 flex min-h-0 flex-1 flex-col overflow-hidden data-[state=inactive]:hidden"
        >
          <SearchHotWords />
        </TabsContent>
        <TabsContent
          value="positive"
          className="mt-0 flex min-h-0 flex-1 flex-col overflow-hidden data-[state=inactive]:hidden"
        >
          <SavedListTab kind="positive" />
        </TabsContent>
        <TabsContent
          value="blacklist"
          className="mt-0 flex min-h-0 flex-1 flex-col overflow-hidden data-[state=inactive]:hidden"
        >
          <SavedListTab kind="blacklist" />
        </TabsContent>
      </Tabs>
    </div>
  )
}
